// classes
import Captcha from "../../../classes/captcha";

import { addInputsChangeListener } from "./input";
import { showSubmittingError } from "./errors";
import { validateForm, handleSubmitContactUsForm } from "./submitForm";
import initTextareaScrollbar from "./initTextareaScrollbar";
import openContactUsModal from "./feedbackModal";

/**
 * Инициализируем необходимые функции после загрузки DOM.
 */
document.addEventListener("DOMContentLoaded", () => {
  const contactButtons = document.querySelectorAll(".contact-form-btn");
  const submitButton = document.getElementById("submit-button");

  const captcha = new Captcha({
    callbackOnSuccess: handleSubmitContactUsForm,
    callbackOnError: showSubmittingError,
  });

  contactButtons.forEach((contactButton) => {
    contactButton.addEventListener("click", () => openContactUsModal({ callback: captcha.renderCaptcha.bind(captcha) }));
  });
  submitButton.addEventListener("click", event => validateForm({ event, validateCaptcha: captcha.validateCaptcha }));

  addInputsChangeListener();
  initTextareaScrollbar(".custom-textarea");
});
